
<template>
    <div class="mem_user">
        <div class="form-group" v-if="obj_to_null(this.init_user)">
            <div class="control-label">
                <label id="jform_init_user_id-lbl" for="jform_init_user_id">
                    Ініціатор
                </label>
            </div>
            
            <user-block key="init_user" :user="init_user"></user-block>
        </div>
        
        <div class="form-group" v-if="obj_to_null(this.recipient)">
            <div class="control-label">
                <label id="jform_rec_user_id-lbl" for="jform_rec_user_id">
                    Затвердження
                </label>
            </div>
            
            <user-block key="recipient" :user="recipient"></user-block>
        </div>
        
        <div class="form-group" v-if="obj_to_null(this.isp_user)">
            <div class="control-label">
                <label id="jform_isp_user_id-lbl" for="jform_rec_user_id">
                    Виконавець
                </label>
            </div>
            
            <user-block key="isp" :user="isp_user"></user-block>
        </div>
        
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import UserBlock from "../../../../../shared/user/user_block/user_block.vue";
export default {
    name: "mem_block_right",
    components: {UserBlock},
    computed: {
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load': "memorandum_inside/is_load"
        }),
        
        work_users() {
            if(this.memorandum.hasOwnProperty("mem_users")) {
                return this.memorandum.mem_users;
            }
            
            return {
                "init" : null,
                'isp' : null,
                'recipient' : null,
            }
        },
        
        init_user() {
            return this.work_users.init;
        },
        
        isp_user() {
            return this.work_users.isp;
        },
        
        recipient() {
            return this.work_users.recipient;
        }
    }
}
</script>



<style scoped>

</style>